module.exports = __webpack_public_path__ + "static/media/backearth.1994b9d2.png";